"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPosResponseToJSON = exports.GetPosResponseFromJSONTyped = exports.GetPosResponseFromJSON = void 0;
var _1 = require("./");
function GetPosResponseFromJSON(json) {
    return GetPosResponseFromJSONTyped(json, false);
}
exports.GetPosResponseFromJSON = GetPosResponseFromJSON;
function GetPosResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'pos': (json['pos'].map(_1.PosFromJSON)),
    };
}
exports.GetPosResponseFromJSONTyped = GetPosResponseFromJSONTyped;
function GetPosResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'pos': (value.pos.map(_1.PosToJSON)),
    };
}
exports.GetPosResponseToJSON = GetPosResponseToJSON;
